import { toast } from 'react-toastify';
import {
  ArchiveBoxIcon,
  ArrowDownTrayIcon,
  EllipsisHorizontalIcon,
} from '@heroicons/react/24/outline';
import { format } from 'date-fns';
import saveAs from 'file-saver';
import { useBoolean } from 'usehooks-ts';

import { ConfirmDialog } from '@/components/ui/confirm-dialog';
import { DialogDescription, DialogTitle } from '@/components/ui/dialog';
import {
  Dropdown,
  DropdownButton,
  DropdownItem,
  DropdownMenu,
} from '@/components/ui/dropdown';

import { ArchiveTasks } from '../api/mutations/archive-tasks';
import { DownloadTasks } from '../api/mutations/download-tasks';

export type TaskBoardActionsProps = {};

export function TaskBoardActions() {
  const archiveTasks = ArchiveTasks.useMutation();
  const downloadTasks = DownloadTasks.useMutation();
  const showArchiveDialog = useBoolean();

  async function handleDownloadClick() {
    const now = new Date();
    const result = await downloadTasks.mutateAsync({
      fileName: `${format(now, 'yyyy-MM-dd_HH:mm:ss')}_done-tasks.csv`,
    });
    saveAs(result.file);
  }

  return (
    <div>
      <Dropdown>
        <DropdownButton variant="ghost" className="p-1 text-zinc-700">
          <EllipsisHorizontalIcon className="size-6" />
        </DropdownButton>
        <DropdownMenu className="absolute right-0 z-50">
          <DropdownItem onClick={handleDownloadClick}>
            <ArrowDownTrayIcon />
            Download done tasks
          </DropdownItem>
          <DropdownItem onClick={() => showArchiveDialog.setTrue()}>
            <ArchiveBoxIcon />
            Archive done tasks&hellip;
          </DropdownItem>
        </DropdownMenu>
      </Dropdown>
      <ConfirmDialog
        open={showArchiveDialog.value}
        submitText="Archive tasks"
        onSubmit={async () => {
          await toast.promise(archiveTasks.mutateAsync(), {
            error: 'An unexpected error happened. Please try again.',
            success: 'Tasks archived',
          });
          showArchiveDialog.setFalse();
        }}
        onClose={() => showArchiveDialog.setFalse()}
      >
        <DialogTitle>Archive all done tasks?</DialogTitle>
        <DialogDescription>
          Do you want to archive all tasks marked as "Done"? Archiving will hide
          these tasks from the task board.
        </DialogDescription>
      </ConfirmDialog>
    </div>
  );
}
